import { contrastingTextColor } from '@doriavboard/shared';
import { cn } from '../../lib/cn';

export function initials(name: string): string {
  const parts = name.trim().split(/\s+/).filter(Boolean);
  if (parts.length === 0) return '?';
  const first = [...(parts[0] ?? '')][0] ?? '';
  const last = parts.length > 1 ? ([...(parts[parts.length - 1] ?? '')][0] ?? '') : '';
  return (first + last).toUpperCase();
}

interface AvatarProps {
  name: string;
  color: string;
  size?: 'xs' | 'sm' | 'md' | 'lg';
  className?: string;
  ring?: boolean;
}

const SIZES = {
  xs: 'size-5 text-[9px]',
  sm: 'size-7 text-[11px]',
  md: 'size-9 text-sm',
  lg: 'size-12 text-base',
};

export function Avatar({ name, color, size = 'md', className, ring }: AvatarProps) {
  return (
    <span
      title={name}
      className={cn(
        'inline-flex shrink-0 select-none items-center justify-center rounded-full font-semibold',
        ring && 'ring-2 ring-white dark:ring-slate-900',
        SIZES[size],
        className,
      )}
      style={{ backgroundColor: color, color: contrastingTextColor(color) }}
    >
      {initials(name)}
    </span>
  );
}
